import axios from 'axios';
import { Toast } from 'vant';

const ALLOWED_EXT = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'heic', 'heif'];

export function isAllowedVoucherFile(file) {
	if (!file) return false;
	const type = (file.type || '').toLowerCase();
	if (type.indexOf('image/') === 0) return true;
	const name = (file.name || '').toLowerCase();
	const ext = name.includes('.') ? name.split('.').pop() : '';
	return ALLOWED_EXT.indexOf(ext) >= 0;
}

export function normalizeVoucherFile(rawFile) {
	return new Promise((resolve, reject) => {
		if (!rawFile) {
			reject(new Error('empty'));
			return;
		}
		const type = (rawFile.type || '').toLowerCase();
		if (type === 'image/jpeg' || type === 'image/jpg' || type === 'image/png') {
			resolve(rawFile);
			return;
		}
		const reader = new FileReader();
		reader.onload = (e) => {
			const img = new Image();
			img.onload = () => {
				const canvas = document.createElement('canvas');
				canvas.width = img.width;
				canvas.height = img.height;
				const ctx = canvas.getContext('2d');
				if (!ctx) {
					reject(new Error('canvas'));
					return;
				}
				ctx.drawImage(img, 0, 0);
				canvas.toBlob((blob) => {
					if (!blob) {
						reject(new Error('blob'));
						return;
					}
					resolve(new File([blob], 'voucher.jpg', { type: 'image/jpeg' }));
				}, 'image/jpeg', 0.9);
			};
			img.onerror = () => reject(new Error('image'));
			img.src = e.target.result;
		};
		reader.onerror = () => reject(new Error('read'));
		reader.readAsDataURL(rawFile);
	});
}

export function uploadVoucherFile(file, { commonUrl, token, language }) {
	const formData = new FormData();
	formData.append('language', language || 'zh_cn');
	formData.append('file', file);
	formData.append('token', token);
	Toast.loading({ forbidClick: true, duration: 20000 });
	return axios.post(commonUrl + '/api/index/bank_link_upload', formData).then((r) => {
		Toast.clear();
		if (r.data && r.data.code === 1) {
			const data = r.data.data;
			return typeof data === 'string' ? data : (data && data.url ? data.url : '');
		}
		const info = r.data && r.data.info;
		const lang = (language || 'zh_cn').toLowerCase().replace('-', '_');
		const msg = typeof info === 'object'
			? (info[lang] || info.zh_cn || '')
			: (info || '');
		return Promise.reject(new Error(msg || 'upload fail'));
	}).catch((err) => {
		Toast.clear();
		return Promise.reject(err);
	});
}
